import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const ClockIcon = (props: IconProps) => (
  <IconBox {...props}>
    <g clipRule="evenodd" fillRule="evenodd">
      <path d="M32 5.81818C17.5402 5.81818 5.81818 17.5402 5.81818 32 5.81818 46.4598 17.5402 58.1818 32 58.1818c14.4598 0 26.1818-11.722 26.1818-26.1818S46.4598 5.81818 32 5.81818zM0 32C0 14.3269 14.3269 0 32 0c17.6731 0 32 14.3269 32 32 0 17.6731-14.3269 32-32 32C14.3269 64 0 49.6731 0 32z" />
      <path d="M32.0009 11.6362c1.6066 0 2.9091 1.3025 2.9091 2.9091V30.202l10.0282 5.0141c1.4371.7185 2.0195 2.4659 1.301 3.9029-.7185 1.4371-2.4659 2.0195-3.9029 1.301l-11.6364-5.8182c-.9856-.4927-1.6081-1.5-1.6081-2.6019V14.5453c0-1.6066 1.3024-2.9091 2.9091-2.9091z" />
    </g>
  </IconBox>
);

export default ClockIcon;
